import { Component, getAssetPath, h, Host, Prop, State, Watch } from "@stencil/core";

interface UrlBlacklist {
    [url: string]: boolean;
}

const failedImageUrls: UrlBlacklist = {};

@Component({
    tag: "ux-country-icon",
    styleUrl: "country-icon.scss",
    shadow: true,
    assetsDirs: ["assets/flags"]
})
export class CountryIcon {
    /** Country code (ISO-2) */
    @Prop() readonly country: string = "";

    /** Size of the icon */
    @Prop({ reflect: true }) readonly size: "s" | "m" | "l" = "s";

    @State() imageUrl: string | null = null;

    @Watch("country")
    setCountry() {
        const { country } = this;
        if (country.length < 2) {
            this.imageUrl = null;
            return;
        }
        const imageUrl = getAssetPath(`./assets/flags/${country.toLowerCase()}.png`);
        this.imageUrl = !failedImageUrls[imageUrl] ? imageUrl : null;
    }

    componentWillLoad() {
        this.setCountry();
    }

    private handleLoadError = (event: ErrorEvent) => {
        failedImageUrls[(event.target as HTMLImageElement).src] = true;
        this.imageUrl = null;
    };

    render() {
        return (
            <Host size={this.size}>
                {/* @ts-expect-error Check for typing */}
                {this.imageUrl !== null && <img src={this.imageUrl} alt={this.country} onError={this.handleLoadError} />}
                {this.imageUrl === null && this.country}
            </Host>
        );
    }
}
